import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RELATION_LIST, RELATION_CHANGE_STATUS, RELATION_ADDEDIT, RELATION_DELETE } from "../../api/constApi";
import { relationListApi, relationChangeStatusApi, AddEditRelationApi, relationDeleteApi } from "../Services/relationService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const relationList = createAsyncThunk(RELATION_LIST, async (payload) => {
    const response = await relationListApi(payload);
    return response.data;
});

export const relationChangeStatus = createAsyncThunk(RELATION_CHANGE_STATUS, async (payload) => {
    const response = await relationChangeStatusApi(payload);
    return response.data;
});

export const addEditRelation = createAsyncThunk(RELATION_ADDEDIT, async (payload) => {
    const response = await AddEditRelationApi(payload);
    return response.data;
});

export const deleteRelation = createAsyncThunk(RELATION_DELETE, async (payload) => {
    const response = await relationDeleteApi(payload);
    return response.data;
});

export const relationSlice = createSlice({
    name: "relation",
    initialState: {
        relation: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(relationList.fulfilled, (state, action) => {
            state.relation = action?.payload;
        });
        builder.addCase(addEditRelation.fulfilled, (state, action) => {
            state.relation = action?.payload?.Data;
          });
    }
});

export default relationSlice.reducer;

// villagelist selector
export const selectRelationList = (state) => state?.relation?.relation;
export const useRelationList = () => {
  const relation = useSelector(selectRelationList);
  return useMemo(() => relation, [relation]);
};